<p *ngIf="loading" class="visually-hidden">
  <ng-content></ng-content>
</p>

<mat-icon class="checkmark" svgIcon="loader" aria-label="Icône de chargement"></mat-icon>
